import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import LogoFallback from "/assets/img/bubbanlogo.jpg";
import { Mail, Phone, MapPin } from "lucide-react";
import axios from "axios";

export default function AdmitCard({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Download Admit Card | Bandarban University",
}) {
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState("");
	const [error, setError] = useState("");
	const [formData, setFormData] = useState({
		mobile_number: "",
		verification_code: "",
	});
	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};
	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError("");
		setSuccess("");

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				...formData, // include name, email, message
			};
			const response = await axios.post(
				`${import.meta.env.VITE_API_BASE_URL}/admit-card`,
				payload,
				{
				  headers: { "Content-Type": "application/json" },
				}
			);
			if (response.data?.responseCode === "00") {        
				const fileUrl = `${import.meta.env.VITE_API_SOURCE_URL}${response.data.responseMsg}`;
				forceDownload(fileUrl, "Admit-Card.pdf");
			} else {
				setError(response.data?.responseMsg || "Something went wrong.");
			}
		} catch (err) {
			setError(err.response?.data?.message || "Server error, please try later.");
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
	
	const forceDownload = (url, filename) => {
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", filename);
		document.body.appendChild(link);
		link.click();
		link.remove();
	};
	
	return (
	<>
	<div className="min-h-screen bg-gray-50">
		 {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-700 to-teal-500  text-white py-20 text-center px-6">
        <motion.h1
          className="text-4xl md:text-5xl font-bold mb-4"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Download Admit Card
        </motion.h1>
        <motion.p
          className="max-w-3xl mx-auto text-lg opacity-90"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Preparing students with cutting-edge skills, research knowledge, and
          innovation in technology.
        </motion.p>
      </section>
	   {/* Contact Form */}
      <section className="max-w-3xl mx-auto py-16 px-6">
        
		
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-lg p-8 space-y-6">
			{/* Success & Error Messages */}
			{success && <div className="mt-4 p-3 rounded-lg bg-green-100 text-green-800 border border-green-300">{success}</div>}
			{error && <div className="mt-4 p-3 rounded-lg bg-red-100 text-red-800 border border-red-300">{error}</div>}
          <div>
            <label className="block font-medium text-gray-700 mb-2">Mobile Number</label>
            <input
              type="text"
			  name="mobile_number"
              value={formData.mobile_number}
              onChange={handleChange}
              className="w-full border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Mobile Number"
              required
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-2">Password</label>
            <input
              type="password"
			  name="verification_code"
              value={formData.verification_code}
              onChange={handleChange}
              className="w-full border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Password"
              required
            />
          </div>
		  
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-teal-600 text-white font-semibold py-3 rounded-lg shadow hover:bg-teal-700 transition"
          >
            {loading ? "Downloading..." : "Download Admit Card"}
          </button>
        </form>
      </section>
	  {/* Contact Info */}
      <section className="bg-gradient-to-r from-teal-600 to-green-600 text-white py-12">
        <div className="max-w-4xl mx-auto px-6 text-center space-y-4">
          <h3 className="text-2xl font-bold mb-4">Admission and Information Division</h3>
          <div className="flex flex-col md:flex-row justify-center gap-6">
            <div className="flex items-center gap-2">
              <MapPin size={20} /> <span>Rowadaw Heights Main Road, Bandarban town</span>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={20} /> <span>+880 1318-305900</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail size={20} /> <span>admission@bubban.ac.bd</span>
            </div>
          </div>
          <button className="mt-6 px-6 py-3 bg-white text-teal-700 font-semibold rounded-lg shadow hover:bg-gray-100">
            Request Appointment
          </button>
        </div>
      </section>
	</div>
	</>
	);
}